///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlannerEulaDTO } from '../../../generated/shared-types.model';

@Injectable({
    providedIn: 'root'
})
export class GtthEulaService {
    readonly baseUrl = '/api/eula';

    constructor(private readonly http: HttpClient) {}

    getEula(): Observable<PlannerEulaDTO> {
        return this.http.get<PlannerEulaDTO>(`${this.baseUrl}`);
    }

    updateEula(file: File): Observable<PlannerEulaDTO> {
        const formData = new FormData();
        formData.append('file', file, file.name);

        return this.http.post<PlannerEulaDTO>(`${this.baseUrl}`, formData);
    }

    acceptNewEula(): Observable<boolean> {
        return this.http.put<boolean>(`${this.baseUrl}`, {});
    }
}
